import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Form, Card, Button, Modal, ModalHeader, ModalBody, ModalFooter, CardBody, OffcanvasHeader, Offcanvas, OffcanvasBody } from 'reactstrap';
import { HelperConstant } from 'helpers/HelperConstant';

import { CustomButton } from 'components/shared/CustomButton';
import { CustomDropdown } from 'components/shared/CustomDropdown';

import { useFormik } from 'formik';
import * as Yup from "yup";

import { ISeriesModel } from 'models/CategoryList.Model';
import { IDownloadProductReport } from 'models/DownloadProductReport.Model';

import CommonService from 'services/CommonService';
import "./Import.css"
import { CustomToaster } from 'components/shared/CustomToaster';
import moment from 'moment';
import { IImportModel } from 'models/Import.Model';
import { FileOpenerOptions, FileOpener } from '@capacitor-community/file-opener';
import { Filesystem, Directory, WriteFileResult } from '@capacitor/filesystem';
import { ScheduleOptions, LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';
import SimpleBar from 'simplebar-react';
import ScrollButton from 'components/Common/ScrollButton';
import CustomLoader from 'components/Common/CustomLoader';

const Import = () => {
    const [ProductList, setProductList] = useState<Array<any>>([]);
    const [brandList, setBrandList] = useState<Array<any>>([]);
    const [seriesModelList, setSeriesModelList] = useState<Array<ISeriesModel>>([]);
    const [productId, setProductId] = useState<any>(0);
    const [productName, setProductName] = useState<any>(null);
    const [brandId, setBrandId] = useState<any>(null);
    const [seriesModelId, setSeriesModelId] = useState<any>(null);
    const [isValidate, setIsValidate] = useState<boolean>(false);
    const [fileName, setFileName] = useState<string>("");
    const fileInputRef = useRef<any>(null);
    const [importedMsg, setImportedMsg] = useState<string>("");
    const [toast, setToast] = useState<boolean>(false);
    const [validateData, setValidateData] = useState<Array<IImportModel>>([]);
    const [modal, setModal] = useState(false);
    const [excelErrors, setExcelErrors] = useState<Array<{ Id: any, Err: any }>>([]);
    const [hoveredColumnId, setHoveredColumnId] = useState(0);
    const [uploadedFile, setUploadedFile] = useState<any>(null);
    const [statusCanvas, setStatusCanvas] = useState<boolean>(false);
    const [historyData, setHistoryData] = useState<Array<any>>([]);
    const [isLoad, setIsLoad] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [inputKey, setInputKey] = useState(0);
    const [fileKey, setFileKey] = useState(Date.now());
    const [importHistoryId,setImportHistoryId]=useState(0);
    const toggle = () => setModal(!modal);

    const toggleStatusCanvas = () => {
        setStatusCanvas(!statusCanvas)
    }

    const successMsg = "Successfully Updated";
    const noUpdated = "There is No Record to Update";
    const customTime = 3000;

    const validation = useFormik<any>({
        enableReinitialize: true,
        initialValues: {
            gadgetId: "",
            brandId: "",
            brandSerie: ""
        },
        validationSchema: Yup.object({
            categoryId: Yup.string().notOneOf(['0']).required("Please Select Category"),

        }),
        onSubmit: (values: any) => {
            // downloadReports(values.startDate, values.endDate, values.fileType);
            // DownloadInvoice();
        }
    });

    const ProductTypeServicesData = () => {
        CommonService.get("ProductType", "GetList").then(res => {
            if (res.status === 200) {
                setProductList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetBrandMasterByProductId = (productTypeId: number) => {
        setProductId(productTypeId);
        CommonService.getWithDoubleEntity("master", "GetBrandMasterByProductId", productTypeId, HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                let selectedName = ProductList?.find(x => x?.Id == productTypeId)?.DisplayName;
                setProductName(selectedName);
                setSeriesModelList([]);
                setBrandList(res.data);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const GetBrands = (BrandId: any) => {
        let GadgetName = ProductList?.find(x => x.Id == validation.values.gadgetId)?.Name?.toLowerCase();
        let BrandName = brandList?.find(x => x.Id == BrandId)?.Name?.toLowerCase();

        if (BrandId > 0) {
            setSeriesModelList([]);
            setBrandId(BrandId);
            CommonService.getWithTripleEntity("master", "GetBrandSeriesByBrandMasterName", GadgetName, BrandName, HelperConstant.serviceTypeId.SELL).then(res => {
                if (res.status === 200) {
                    setSeriesModelList(res.data);
                }
            }).catch(e => {
                console.log(e);
            });
        }
    }

    const getSeriesModel = (seriesModelId: any) => {
        setSeriesModelId(seriesModelId);
    }

    const DownloadInvoice = () => {
        if (productId > 0) {
            const data: IDownloadProductReport = {
                ProductTypeId: productId,
                BrandMasterId: brandId,
                BrandSeriesId: seriesModelId,
                SortOrder: "",
                SortOrderColumn: "",
                CategoryId: 0,
                SeriesModelId: undefined
            }
            CommonService.post("Sell", "DownloadProductListForImport", data).then(res => {
                if (res.status === 200) {
                    if (Capacitor.isNativePlatform()) {
                        let concatedBase64 = "data:text/csv;base64, " + res.data;
                        let pathName = `DOFY_${productName}_${moment(new Date()).format("DD-MMM-YYYY_HH.mm")}.csv`
                        downloadMobileInvoice(res.data, pathName);
                    } else {
                        downloadCSV(res.data);
                    }
                }
            });
        }
    }

    const downloadCSV = (csvData) => {
        const decodedData = atob(csvData);
        const blob = new Blob([decodedData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `DOFY_${productName}_${moment(new Date()).format("DD-MMM-YYYY_HH.mm")}.csv`);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };

    const downloadMobileInvoice = async (file: any, path: any) => {
        Filesystem.writeFile({
            path: path,
            data: file,
            directory: Directory.Documents,
            recursive: true
        }).then((res: WriteFileResult) => {
            showInvoiceNotification(res.uri, path);
        }).catch(e => console.log(e));
    };

    const openDownloadedFile = async (uri: any) => {
        try {
            const fileOpenerOptions: FileOpenerOptions = {
                filePath: uri,
                openWithDefault: true,
            };
            await FileOpener.open(fileOpenerOptions);

        } catch (e) {
            console.log('Error opening file', e);
        }
    };

    const showInvoiceNotification = async (uri: any, name: any) => {
        let options: ScheduleOptions = {
            notifications: [
                {
                    id: 2,
                    title: name,
                    body: "Download completed. File saved in Documents",
                    extra: { uri: uri },
                    actionTypeId: "open_pdf"
                }
            ]
        };

        try {
            await LocalNotifications.schedule(options);
        } catch (error) {
            console.log(error);
        }

        LocalNotifications.addListener('localNotificationActionPerformed', async (notification) => {
            if (notification.notification.actionTypeId === 'open_pdf') {
                const uri = notification.notification.extra.uri;
                openDownloadedFile(uri);
            }
        });
    }

    const handleFiles = (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setIsValidate(false);
            // const file = fileInputRef.current.files[0];
            setFileName(file.name);
            handleSubmit(file);

            event.target.value = "";
            setFileKey(Date.now());
        }
    };

    const handleSubmit = (file) => {
        if (file) {
            setExcelErrors([]);
            setUploadedFile(file);
            const formData = new FormData();
            formData.append('file', file as any);
            importData(formData);
        }
    }

    const bulkUpdate = () => {
        let result: Array<any> = [];
        setIsUpload(true);
        validateData.forEach((x, i) => {
            if ((x.MinimumValue != x.LiveMinValue) || (x.MaximumValue != x.LiveMaxValue) || (x.IsRestricted != x.CurrentIsRestricted) || (x.EndDate != x.CurrentEndDate) || (x.DisplayForSale != x.CurrentDisplayForSale)) {
                result.push(x);
            }
        });

        if (result.length == 0) {
            setImportedMsg(noUpdated);
            setToast(true);
        }

        else {
            CommonService.post("Sell", `BulkImport?importHistoryId=${importHistoryId}`,{}).then(res => {
                if (res.status == 200) {
                    setToast(true);
                    toggle();
                    setImportedMsg(res.data);
                    if (res.data == successMsg) {
                        setTimeout(() => {
                            window.location.reload();
                        }, customTime);
                    }
                    // setIsUpload(false);
                }
            }).catch(e => {
                console.log(e);
            });
        }
    }

    const importData = (file) => {
        setIsLoad(true);
        CommonService.postWithFormData("Sell", "ValidateImportList", file).then(res => {
            if (res.status === 200) {
                let data: Array<IImportModel> = res.data;
                setImportHistoryId(data[0].ImportHistoryId);
                statusValidator(data);
                setIsLoad(false);
            }
        }).catch(e => {
            // fileInputRef.current = null;
            if (e?.response?.data?.Message == "Input string was not in a correct format.") {
                setImportedMsg("Letters not allowed in numbers field, kindly Check the Excel.");
            }
            else {
                setImportedMsg("Upload Exported Excel or Missing headers");
            }
            setToast(true);
            setIsLoad(false);
        });
    }

    const percentageHandler = (LiveMinValue, MinimumValue) => {
        if (LiveMinValue != MinimumValue) {
            let percentage = ((MinimumValue - LiveMinValue) / LiveMinValue) * 100;
            let color = ""
            if ((percentage > 0 && percentage < 2) || (percentage < 0 && percentage > -2)) {
                color = 'highlight-green';
            }
            if ((percentage >= 2 && percentage <= 5) || (percentage <= -2 && percentage >= -5)) {
                color = 'highlight-orange';
            }
            if (percentage > 5 || percentage < -5) {
                color = 'highlight-red';
            }

            return <p className={color}>({percentage.toFixed(2)}%)</p>
        }
        return ""
    }

    const changesMade = (val1, val2) => {
        if (val1 != val2) {
            return 'changes-made';
        }
        return "";
    }

    const removeHandler = () => {
        setValidateData([]);
        setExcelErrors([]);
        fileInputRef.current = null;
    }

    const tickSvg = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path fill="#c8e6c9" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#4caf50" d="M34.586,14.586l-13.57,13.586l-5.602-5.586l-2.828,2.828l8.434,8.414l16.395-16.414L34.586,14.586z" /></svg>;
    const wrongSvg = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>;

    const statusValidator = (items: Array<IImportModel>) => {
        const err = (id, err) => {
            return {
                Id: id,
                Err: err
            }
        }
        for (let item of items) {

            if (item.Duplicate == true) {
                excelErrors.push(err(item.Id, "You couldn't change the following columns: Id, Product, Brand, Series, Model, and Variants. Please review the highlighted column to correct the mistake."));
            }

            if (item.ProductTypeName != item.CurrentProductTypeName) {
                excelErrors.push(err(item.Id, "ProductTypeName is Empty or Changed"));
            }
            if (item.BrandMasterName != item.CurrentBrandMasterName) {
                excelErrors.push(err(item.Id, "BrandMasterName is Empty or Changed"));
            }
            if (item.BrandSeriesName != item.CurrentBrandSeriesName) {
                excelErrors.push(err(item.Id, "BrandSeriesName is Empty or Changed"));
            }
            if (item.SeriesModelName != item.CurrentSeriesModelName) {
                excelErrors.push(err(item.Id, "SeriesModelName is Empty or Changed"));
            }
            if (item.Name != item.CurrentName) {
                excelErrors.push(err(item.Id, "Name is Empty or Changed"));
            }
            if (item.MinimumValue > item.MaximumValue) {
                excelErrors.push(err(item.Id, "Minimum Price is greater than maximum price"));
            }

            if (item.Errors?.length > 0) {
                for (let eItem of item.Errors) {
                    excelErrors.push(err(item.Id, eItem));
                }
            }
        }
        setExcelErrors(excelErrors);
        setValidateData(items);
        setIsValidate(true);
    }

    const statusShower = (id) => {
        if (excelErrors?.filter(x => x?.Id == id).length > 0) {
            return wrongSvg;
        }
        else {
            return tickSvg;
        }
    }

    const hoverStatusHandler = (id) => {
        if (excelErrors?.filter(x => x?.Id == id).length > 0) {
            setHoveredColumnId(id);
        }
        else {
            setHoveredColumnId(0);
        }
    }

    const handleReset = () => {
        validation.resetForm();
        setBrandList([]);
        setSeriesModelList([]);
        setProductId(0);
        setBrandId(0);
        setSeriesModelId(0);
    };

    const getImportHistory = () => {
        CommonService.get("sell", "GetImportHistory").then(res => {
            if (res.status == 200) {
                const data = res.data;
                const groupedData = groupByFileName(data);
                setHistoryData(groupedData);
            }
        }).catch(e => console.log(e));
    }

    const groupByFileName = (data) => {
        const grouped = data.reduce((acc, { FileName, ...rest }) => {
            let group = acc.find(g => g.FileName === FileName);

            if (!group) {
                group = { FileName, items: [] };
                acc.push(group);
            }
            group.items.push(rest);
            return acc;
        }, []);

        return grouped;
    };

    const convertBytesToCSV = (byteData) => {
        // Ensure that byteData is an ArrayBuffer
        const text = new TextDecoder().decode(new Uint8Array(byteData));
        return text;
    };

    const downloadImportHistoryById = (id, fileName) => {
        CommonService.getWithSingleEntity("sell", "DownloadImportHistoryById", id).then(res => {
            if (res.status == 200) {
                const csvData = convertBytesToCSV(res.data);
                const blob = new Blob([csvData], { type: 'text/csv' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${fileName?.split("|")[0]}.csv`;
                link.click();
            }
        }).catch(e => console.log(e));
    }


    const toISODateString = (dateStr: string) => {
        const isoDate = moment(dateStr, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DDTHH:mm:ss");
        return isoDate;
    }

    useEffect(() => {
        ProductTypeServicesData();
        // getImportHistory();
    }, []);

    return (
        <div className="page-content">
            <ScrollButton />
            <CustomLoader isOpen={isUpload} />
            <CustomToaster message={importedMsg} color={importedMsg == successMsg ? 'text-success' : "text-danger"} toast={toast} setToast={setToast} customTime={customTime} />
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Bulk Update Warning</ModalHeader>
                <ModalBody>
                     <p>Please verify all the modified data of Price, and all modified data, when you click "Update" it will be displayed in public site immediately</p>
                    <p>Are you sure want to execute the bulk update?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={bulkUpdate}>
                        Update
                    </Button>{' '}
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Container fluid>
                <div>
                    <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>IMPORT</h5>
                </div>
                <div className=''>
                    <Form className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col lg={8} >
                                <Row>
                                    <Col lg={4}>
                                        <CustomDropdown
                                            name="gadgetId"
                                            label="Gadget"
                                            id={"gadgetId"}
                                            value={validation.values.gadgetId || ""}
                                            onChange={(e) => { validation.handleChange(e); GetBrandMasterByProductId(e.target.value) }}
                                            data={ProductList}
                                            error={validation.errors.gadgetId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.gadgetId}
                                            invalid={validation.touched.gadgetId && validation.errors.gadgetId ? true : false}
                                            valueField="Id"
                                            displayField="DisplayName"
                                        // isMandatory={true}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <CustomDropdown
                                            name="brandId"
                                            label="Brand"
                                            id={"brandId"}
                                            onChange={(e) => { validation.handleChange(e); GetBrands(e.target.value) }}
                                            value={validation.values.brandId || ""}
                                            data={brandList}
                                            error={validation.errors.brandId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.brandId}
                                            invalid={validation.touched.brandId && validation.errors.brandId ? true : false}
                                            valueField="Id"
                                            displayField="DisplayName"
                                        // isMandatory={true}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <CustomDropdown
                                            name="modelId"
                                            label="Brand Series"
                                            id={"modelId"}
                                            value={validation.values.modelId || ""}
                                            onChange={(e) => { validation.handleChange(e); getSeriesModel(e.target.value) }}
                                            data={seriesModelList}
                                            error={validation.errors.modelId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.modelId}
                                            invalid={validation.touched.modelId && validation.errors.modelId ? true : false}
                                            valueField="Id"
                                            displayField="Name"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={4}>
                                <Row>
                                    <Col xl="12" sizeSm="11" md="12" xs="12" lg="12" className="d-flex justify-content-end">
                                        <CustomButton
                                            disabled={productId == 0}
                                            type="button"
                                            btnClassName="ms-2 btn-success w-md mt-4"
                                            iconClasssName="mdi mdi-logout"
                                            name="EXPORT"
                                            onClick={() => DownloadInvoice()}
                                        />
                                        <CustomButton
                                            disabled={undefined}
                                            type="button"
                                            btnClassName={"ms-2 btn-warning w-md mt-4"}
                                            iconClasssName={''}
                                            name="Reset"
                                            onClick={handleReset}
                                        />
                                        {/* <CustomButton
                                            disabled={undefined}
                                            type="button"
                                            btnClassName={"ms-2 btn-territory w-md mt-4"}
                                            iconClasssName={''}
                                            name="History"
                                            onClick={toggleStatusCanvas}
                                        /> */}
                                    </Col>
                                </Row>
                            </Col>
                            <Offcanvas
                                className='import'
                                isOpen={statusCanvas}
                                direction="end"
                                toggle={toggleStatusCanvas}
                            >
                                <OffcanvasHeader toggle={toggleStatusCanvas}>
                                    <i className='fa fa-history text-dofy me-2 font-size-15'></i>
                                    <span className='m-0 text-dofy fw-semibold'>Import History</span>
                                </OffcanvasHeader>
                                <OffcanvasBody>
                                    <SimpleBar className="h-100">
                                        <div className="container d-flex justify-content-center">
                                            <ul className="list-group text-white">
                                                {historyData?.length > 0 ? historyData.map((x, i) => (
                                                    <li key={i} className="list-group-item d-flex justify-content-between align-content-center">
                                                        <div className="d-flex flex-row">
                                                            <img src={require("../../assets/images/excel.png")} style={{ width: "40px", height: "40px", marginTop: "15px" }} />
                                                            <div className="details">
                                                                <h6 className="mb-0 cursor-pointer file-name" onClick={() => downloadImportHistoryById(x.Id, x.FileName)}>{x.FileName}</h6>
                                                                <div className="about">
                                                                    <span style={{ whiteSpace: "nowrap" }}>By : {x.FullName}</span>
                                                                    <span>{moment(x.Created)?.format("L")}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="check">
                                                            <i className='bx bx-download cursor-pointer'></i>
                                                        </div>
                                                    </li>
                                                ))
                                                    :
                                                    <li className="list-group-item d-flex justify-content-between align-content-center">
                                                        <div className="d-flex flex-row">
                                                            <div className="details">
                                                                <h6 className="mb-0 file-name">No History</h6>
                                                            </div>
                                                        </div>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </SimpleBar>
                                </OffcanvasBody>
                            </Offcanvas>
                        </Row>
                        <Row className='mt-5'>
                            <Col lg={12}>
                                {validateData?.length == 0 ?
                                    <div className="file-upload">
                                        <div className={`image-upload-wrap`}>
                                            <input key={fileKey}
                                                type="file" className="file-upload-input"
                                                onChange={handleFiles}
                                            />
                                            <div className="drag-text">
                                                <h3>{isLoad ? <i className='bx bx-loader bx-spin font-size-24'></i> : "Select the csv or xls file"}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <Card className='ier-card'>
                                        <h5 className='text-center'>{fileName}</h5>
                                        <Row>
                                            <Col className='text-end'>
                                                <Button className='btn-danger me-2' onClick={() => removeHandler()}>Cancel</Button>
                                                <Button disabled={(!isValidate || excelErrors.length > 0)} className='btn-success' onClick={() => (!isValidate || excelErrors.length > 0) ? null : toggle()}>Update</Button>
                                            </Col>
                                        </Row>

                                        <div className="scrollable-container">
                                            <table className="ex-data-table">
                                                <thead>
                                                    <tr>
                                                        <th>Status</th>
                                                        <th>Id</th>
                                                        <th>Product</th>
                                                        <th>Brand</th>
                                                        <th>Series</th>
                                                        <th>Model</th>
                                                        <th>Variants</th>
                                                        <th>LiveMin</th>
                                                        <th>CurMin</th>
                                                        <th>LiveMax</th>
                                                        <th>CurMax</th>
                                                        <th>DisplayForSale</th>
                                                        <th>RestrictedForMinPrice</th>
                                                        <th>ExpirationDate</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {validateData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className='cursor-pointer' onMouseEnter={() => hoverStatusHandler(item.CurrentId)} onMouseLeave={() => hoverStatusHandler(0)}>{statusShower(item.CurrentId)}</td>
                                                            <td className={changesMade(item.Id, item.CurrentId)}>{item.Id}</td>
                                                            <td className={changesMade(item.ProductTypeName, item.CurrentProductTypeName)}>{item.ProductTypeName}</td>
                                                            <td className={changesMade(item.BrandMasterName, item.CurrentBrandMasterName)}>{item.BrandMasterName}</td>
                                                            <td className={changesMade(item.BrandSeriesName, item.CurrentBrandSeriesName)}>{item.BrandSeriesName}</td>
                                                            <td className={changesMade(item.SeriesModelName, item.CurrentSeriesModelName)}>{item.SeriesModelName}</td>
                                                            <td className={changesMade(item.Name, item.CurrentName)}>{item.Name}</td>
                                                            <td>{item.LiveMinValue}</td>
                                                            <td>{item.MinimumValue} {percentageHandler(item.LiveMinValue, item.MinimumValue)}</td>
                                                            <td>{item.LiveMaxValue}</td>
                                                            <td>{item.MaximumValue} {percentageHandler(item.LiveMaxValue, item.MaximumValue)}</td>
                                                            <td className={changesMade(item.DisplayForSale, item.CurrentDisplayForSale)}>{item.DisplayForSale ? 'Yes' : 'No'}</td>
                                                            <td className={changesMade(item.IsRestricted, item.CurrentIsRestricted)}>{item.IsRestricted ? 'Yes' : 'No'}</td>
                                                            <td className={changesMade(moment(item.EndDate).format("MMM-DD-YYYY"),moment(item.CurrentEndDate).format("MMM-DD-YYYY"))}>{item.EndDate ? moment(item.EndDate).format("MMM-DD-YYYY") : ""}</td>
                                                            {item.CurrentId == hoveredColumnId ?
                                                                <div className='err-module'>
                                                                    {excelErrors.filter(x => x.Id == item.Id).map((val, i) => (
                                                                         <li key={i}>{val.Err}</li>
                                                                    ))}
                                                                </div>
                                                                :
                                                                <div style={{ position: "absolute" }}></div>
                                                            }
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Card>
                                }
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Container>
        </div>
    );
};

export default Import;